import axios from 'axios'
import API from './api.js'

export default {
    async getFileContentArrayBuffer(url) {
        try {
            let response = await API.HTTPS.get(url + '/content', { responseType: "arraybuffer" })

            return { code: 0, data: response }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async getFileContentBlob(url) {
        try {
            let response = await API.HTTPS.get(url + '/content', { responseType: "blob" })

            return { code: 0, data: response }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async getZipContentBlob(url, ids) {
        try {
            let response = await API.HTTPS.post(url + '/zipcontent', ids, { responseType: "blob" })

            return { code: 0, data: response }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async uploadFile(folderId, id, data, idals) {
        try {
            let response = await API.HTTPS.post(process.env.VUE_APP_FILEAPI_URL + '/folder/' + folderId + '/' + id + '/upload?idALS=' + idals, data, { headers: {"Content-Type": "multipart/form-data" }})

            return { code: 0, data: response }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async uploadXmlFile(fileName, data) {
        try {
            let response = await axios.post(process.env.VUE_APP_IMPORTAPI_URL + '/SendXML/' + fileName, data)

            return { code: 0, data: response }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}